import { useRef, useEffect, useState } from 'react'
import {Panel, Button} from './index'
import {FiPlusCircle, FiXCircle} from 'react-icons/fi'

import useTranlation from '../../translation/hook'


export default function UICardLogo({state, methods, ...props}){

    const t = useTranlation()

    const [uiState, setState ] = useState({
        uploaded: false
    })
    
    
    const ref = useRef()

    function onFileChange(e){
        e.preventDefault()
        
        const {files} = e.target
        
        const img = files[0]
        const url = URL.createObjectURL(img)

        methods.setCardLogoUrl(url)        
        
        methods.setCardLogoBase64(img)
        
        setState(oldState => ({...oldState, uploaded: true}))
        

    }
    
    function toggleUpload(e){
        e.preventDefault()
        const input = ref.current
        input.click()
    }
    
    function deleteImmagine(){
        methods.setCardLogoUrl()
        setState(oldState => ({...oldState, uploaded: false}))
    }
    
    
    
    return (
        <Panel >
            <div style={{display: "flex", flexDirection:"column", width: "100%"}}>
            { uiState.uploaded ? (
                <p onClick={deleteImmagine} class="newFileParagraph"><FiXCircle/><span>{t("site_pages_shop_app_remove_logo")}</span> </p>
            ) : ( 
                <p onClick={toggleUpload} class="newFileParagraph"><FiPlusCircle /><span>{t("site_pages_shop_app_add_logo")}</span> </p>
            )}
                <input type="file" style={{display: "none"}} ref={ref} onChange={onFileChange} accept="image/png, image/svg"/>
                <p style={{width: "350px"}}>
                    <small>{t("site_pages_shop_app_logo_info")}</small>
                </p>
            </div>
        </Panel>
    )
}
